import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { switchToLevel } from "./helpers";
import { goToPage } from "../../../editor/events";

const revealStructure = (hostId: string): StepType[] => [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.secretPower}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-structure",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.structureTabIntro}
						<br />
						<br />
						{text.tourSteps.structureBuiltWithText}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(3);
			goToPage(hostId, "QP", 1);
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.structureLabels}
						<br />
						<br />
						{text.tourSteps.structureAiWrites}
					</span>
				)}
			/>
		),
		position: "left",
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.structureTypeSlide}
						<br />
						{text.tourSteps.structureTypeTitle}
						<br />
						{text.tourSteps.structureTypeImage}
						<br />
						<br />
						{text.tourSteps.structureThatsAll}
					</span>
				)}
			/>
		),
		position: "left",
	},
	{
		selector: ".vocab-bar",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.structureHints}
			/>
		),
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.structureInstantPreview}
			/>
		),
		position: "left",
	},
];

export default revealStructure;
